//  angularModalService.js
//
//  Service for showing modal dialogs.

/***** JSLint Config *****/
/*global angular  */
(function() {

  'use strict';

  var module = angular.module('cian.ui.popup', ['cian.ui.position', 'cian.ui.visible', 'cian.ui.stackedMap']);

  module.factory('PopupService', ['$document', '$compile', '$controller', '$http', '$rootScope', '$q', '$templateCache', '$timeout', '$$stackedMap', '$window', '$visible', '$log',
    function($document, $compile, $controller, $http, $rootScope, $q, $templateCache, $timeout, $$stackedMap, $window, $visible, $log) {

    var openedPopups = $$stackedMap.createNew();
    //  Get the body of the document, we'll add the modal to this.
    var body = $document.find('body');

    function PopupService() {

      var self = this;
      var currentAnchorElement;
      var popupsCounter = 0;

      //  Returns a promise which gets the template, either
      //  from the template parameter or via a request to the
      //  template url parameter.
      var getTemplate = function(template, templateUrl) {
        var deferred = $q.defer();
        if(template) {
          deferred.resolve(template);
        } else if(templateUrl) {
          // check to see if the template has already been loaded
          var cachedTemplate = $templateCache.get(templateUrl);
          if(cachedTemplate !== undefined) {
            deferred.resolve(cachedTemplate);
          }
          // if not, let's grab the template for the first time
          else {
            $http({method: 'GET', url: templateUrl, cache: true})
              .then(function(result) {
                // save template into the cache and return the template
                $templateCache.put(templateUrl, result.data);
                deferred.resolve(result.data);
              }, function(error) {
                deferred.reject(error);
              });
          }
        } else {
          deferred.reject("No template or templateUrl has been specified.");
        }
        return deferred.promise;
      };

       // TODO debounce
      function placePopup(popupElement, anchorElement, align) {
        var tailElement = $(angular.element(popupElement[0].getElementsByClassName('s-popup__tail'))),
            popupLeftPos = 0,
            tailLeftPos = 0;

        currentAnchorElement = anchorElement;

        popupElement = $(popupElement);
        anchorElement = $(anchorElement);
        $timeout(function() {
          popupElement.css({'visibillity': 'hidden', 'top': 0, 'left': 0, 'display': 'block'});
          popupLeftPos = anchorElement.offset().left + anchorElement.innerWidth() / 2 - popupElement.innerWidth() / 2;
          if (align === 'right') {
              popupLeftPos = anchorElement.offset().left - popupElement.innerWidth() + anchorElement.innerWidth();
          } else if (align === 'left') {
              popupLeftPos = anchorElement.offset().left;
          }

          popupElement.show();
          popupElement.css('margin', '0');
          popupElement.css({
            'top': anchorElement.offset().top,
            'left': popupLeftPos,
            'margin': (-tailElement.position().top + anchorElement.outerHeight(true)) + 'px 0 0 0',
            'visibillity': 'visible'
          });

          anchorElement.addClass('is-popup-open');

          tailElement.css('left', '0');
          tailLeftPos = ( anchorElement.width() / 2 - tailElement.width() / 2 + anchorElement.offset().left - tailElement.offset().left);
          tailElement.css('left', tailLeftPos);
        });
      };

      self.close = function() {
        $log.info('Popup is closed already')
      }

      self.show = function (options) {
        var lastPopup = openedPopups.top();

        options.behavior = options.behavior || 'dropdown';

        if (lastPopup) {
          lastPopup.value.close();
          openedPopups.removeTop();
          if (currentAnchorElement == options.anchorElement) {
            return $q.defer().promise;
          }
        }
        // if (options.event) event.preventDefault();
        //  Create a deferred we'll resolve when the modal is ready.
        var deferred = $q.defer();

        //  Validate the input parameters.
        var controllerName = options.controller;
        if(!controllerName) {
          deferred.reject("No controller has been specified.");
          return deferred.promise;
        }

        //  If a 'controllerAs' option has been provided, we change the controller
        //  name to use 'as' syntax. $controller will automatically handle this.
        if(options.controllerAs) {
          controllerName = controllerName + " as " + options.controllerAs;
        }

        //  Get the actual html of the template.
        getTemplate(options.template, options.templateUrl)
          .then(function(template) {
            // Namespace to make events unique for each popup
            var popupNamespace = 'cian.ui.popup' + ++popupsCounter;

            //  Create a new scope for the modal.
            var popupScope = options.scope?options.scope:$rootScope.$new();
            popupScope.isOpen = true;

            var closePopup = function() {
              var lastPopup = openedPopups.top();
              if (lastPopup) {
                lastPopup.value.close();
                openedPopups.removeTop();
                if (currentAnchorElement == options.anchorElement) {
                  return $q.defer().promise;
                }
              } else if (inputs) {
                inputs.close();
              }
            }

            self.close = closePopup;

            var checkOutsideClick = function(e) {
              $log.info('checkOutsideClick')
              // if (!popupElement) { return }
              var isInside = popupInnerContent.find($(e.target)).length > 0 || popupInnerContent.is($(e.target));
              if (isInside) return

              // если родительского элемента нет, значит элемент уже уничетожен
              // в таком случае не закрываем попап
              // это нужно, чтобы карта не закрывалась при завершении рисования полигона
              var isDestroyedElement = !e.target.parentElement
              if (isDestroyedElement) return

              closePopup();
            };

            //  Create the inputs object to the controller - this will include
            //  the scope, as well as all inputs provided.
            //  We will also create a deferred that is resolved with a provided
            //  close function. The controller can then call 'close(result)'.
            //  The controller can also provide a delay for closing - this is
            //  helpful if there are closing animations which must finish first.
            var closeDeferred = $q.defer();
            var inputs = {
              $scope: popupScope,
              close: function(result, delay) {
                if (typeof options.onClose === 'function') options.onClose();
                if(delay === undefined || delay === null) delay = 0;
                $timeout(function() {
                  // Use namespace to prevent disabling other popups from closing
                  $document.off('click.' + popupNamespace, checkOutsideClick);

                  if (options.behavior === 'dropdown') {
                    // Прекращаем следить за размерами кнопки и окна
                    angular.element($window).off('resize.' + popupNamespace);
                    stopWatchingWidth();
                  }

                  if (options.behavior === 'popup') {
                    body.css('overflow', '');
                  }

                  //  Resolve the 'close' promise.
                  closeDeferred && closeDeferred.resolve(result);

                  // Без таймаута не убирается класс, если закрывать попап по нажатию на элемент внутри попапа
                  // Например, при выборе типа жилья в offer-type-browser
                  $timeout(function () {
                    angular.element(options.anchorElement).removeClass('is-popup-open');
                  });

                  //  We can now clean up the scope and remove the element from the DOM.
                  popupScope && popupScope.$destroy();
                  popupElement && popupElement.remove();
                  var lastPopup = openedPopups.top();
                  if (lastPopup) {
                    openedPopups.removeTop();
                  }

                  //  Unless we null out all of these objects we seem to suffer
                  //  from memory leaks, if anyone can explain why then I'd
                  //  be very interested to know.
                  if (inputs) {
                    inputs.close = null;
                  }
                  deferred = null;
                  closeDeferred = null;
                  popup = null;
                  inputs = null;
                  popupElement = null;
                  popupScope = null;
                  checkOutsideClick = null;
                }, delay);
              }
            };

            openedPopups.add(popupScope, {
              close: closePopupBind
            });

            function closePopupBind() {
              if (popupScope && popupScope.isOpen) inputs.close();
            }

            //  If we have provided any inputs, pass them to the controller.
            if(options.inputs) {
              for(var inputName in options.inputs) {
                inputs[inputName] = options.inputs[inputName];
              }
            }

            //  Parse the popup HTML into a DOM element (in template form).
            var popupElementTemplate = angular.element(template);

            //  Compile then link the template element, building the actual element.
            //  Set the $element on the inputs so that it can be injected if required.
            var linkFn = $compile(popupElementTemplate);
            var popupElement = linkFn(popupScope);
            var popupInnerContent = popupElement;

            inputs.$element = popupElement;

            if (options.className) {
              popupElement.addClass(options.className);
            }

            //  Create the controller, explicitly specifying the scope to use.
            var popupController = $controller(controllerName, inputs);

            //  Finally, append the popup to the dom.
            if (options.appendElement) {
              // append to custom append element
              options.appendElement.append(popupElement);
            } else {
              // append to body when no custom append element is specified
              body.append(popupElement);
            }

            if (options.behavior === 'popup') {
              popupElement.addClass('s-popup_behavior_popup');
              // Клик внутри попапа определяем по содержимому
              popupInnerContent = $(popupElement).find('.s-popup__wrapper');

              // Отключаем скролл страницы
              body.css('overflow', 'hidden');
              popupElement.show();
            }

            if (options.behavior === 'dropdown') {
              placePopup(popupElement, options.anchorElement, options.align);

              // Если у кнопки изменился размер, позиционируем хвостик по центру
              var stopWatchingWidth = $rootScope.$watch(function () {
                return options.anchorElement.offsetWidth;
              }, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                  placePopup(popupElement, options.anchorElement, options.align);
                }
              });

              angular.element($window).on('resize.' + popupNamespace, function () {
                placePopup(popupElement, options.anchorElement, options.align);
              });
            }

            // if (options.scrollIfNotInViewport && !$visible.test(popupElement)) {
            //   var currentScrollTop = $('body').scrollTop(),
            //       viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
            //       newScrollTop = currentScrollTop + viewportHeight - $(popupElement).offset().top;

            //   $('body').stop().animate({
            //     scrollTop: newScrollTop
            //   }, 2000, 'swing');
            // }

            //  We now have a popup object...
            var popup = {
              controller: popupController,
              scope: popupScope,
              element: popupElement,
              close: closeDeferred.promise/*,
              isInViewport: $visible.test(popupElement)*/
            };

            $document.on('click.' + popupNamespace, checkOutsideClick);

            //  ...which is passed to the caller via the promise.
            deferred.resolve(popup);
          })
          .then(null, function(error) { // 'catch' doesn't work in IE8.
            deferred.reject(error);
          });

        return deferred.promise;
      };

    }

    return new PopupService();
  }]);

}());



//////////////////
// WEBPACK FOOTER
// ../components/ui/src/popup/popup.js
// module id = 907
// module chunks = 0